@use "../../styles/variables" as vars;

.toastWrapper {
  position: fixed;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
}

.toast {
  width: fit-content;
  max-width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  pointer-events: auto;
  animation: slideInDown 0.3s ease;
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-12px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.toast__icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  flex-shrink: 0;
  background: transparent;
}

.toast__icon {
  font-size: 18px;
  background: radial-gradient(circle at center, vars.$white 0%, vars.$white 45%, transparent 50%);
}

.toast__message {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
  color: #e0e0e0;
}

/* Info */
.toast--info {
  background: #1e1e1e;
  border: 1px solid vars.$primary-color;
}

/* Success */
.toast--success {
  background: #1e1e1e;
  border: 1px solid vars.$border-green;
}

/* Error */
.toast--error {
  background: #1e1e1e;
  border: 1px solid vars.$text-red;
}

/* Warning */
.toast--warning {
  background: #1e1e1e;
  border: 1px solid vars.$border-yellow;
}

.toast--info .toast__icon-container {
  color: vars.$primary-color;
}

.toast--success .toast__icon-container {
  color: vars.$border-green;
}

.toast--error .toast__icon-container {
  color: vars.$text-red;
}

.toast--warning .toast__icon-container {
  color: vars.$border-yellow;
}
